module.exports = __webpack_public_path__ + "img/professioneel-etiket-bierfles-quadruppel-blond-business-beer-nederland-1.eec66e93.jpg";